// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unauthorized-container {
	max-width: 640px;
	margin: 80px auto;
	padding: 24px;
	text-align: center;
}

.unauthorized-container h2 {
	margin-bottom: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/app/unauthorized-user/unauthorized-user.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB","sourcesContent":[".unauthorized-container {\r\n\tmax-width: 640px;\r\n\tmargin: 80px auto;\r\n\tpadding: 24px;\r\n\ttext-align: center;\r\n}\r\n\r\n.unauthorized-container h2 {\r\n\tmargin-bottom: 12px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
